const BELTS = [
  { id: 0, name: 'white', minAge: 4, maxAge: 999 },
  { id: 1, name: 'grey', minAge: 4, maxAge: 15 },
  { id: 2, name: 'yellow', minAge: 7, maxAge: 15 },
  { id: 3, name: 'orange', minAge: 10, maxAge: 15 },
  { id: 4, name: 'green', minAge: 13, maxAge: 15 },
  { id: 5, name: 'blue', minAge: 16, maxAge: 999 },
  { id: 6, name: 'purple', minAge: 16, maxAge: 999 },
  { id: 7, name: 'brown', minAge: 18, maxAge: 999 },
  { id: 8, name: 'black', minAge: 19, maxAge: 999 },
  { id: 9, name: 'black-1', minAge: 19, maxAge: 999 },
  { id: 10, name: 'black-2', minAge: 19, maxAge: 999 },
  { id: 11, name: 'black-3', minAge: 19, maxAge: 999 },
  { id: 12, name: 'black-4', minAge: 19, maxAge: 999 },
  { id: 13, name: 'black-5', minAge: 19, maxAge: 999 },
  { id: 14, name: 'black-6', minAge: 19, maxAge: 999 },
  { id: 15, name: 'red-and-black', minAge: 19, maxAge: 999 },
  { id: 16, name: 'red-and-white', minAge: 19, maxAge: 999 },
  { id: 17, name: 'red-9', minAge: 19, maxAge: 999 },
  { id: 18, name: 'red-10', minAge: 19, maxAge: 999 }
]

export function belts(options = { forAge: null, withBlackDegrees: false }) {
  let belts

  if (options.withBlackDegrees) {
    belts = [...BELTS]
  } else {
    belts = BELTS.filter(belt => belt.id <= 8)
  }

  if (options.forAge) {
    return belts.filter(belt => belt.minAge <= options.forAge && belt.maxAge >= options.forAge)
  } else {
    return belts
  }
}

export function byName(name) {
  return BELTS.find(belt => belt.name === name)
}

export function byId(id) {
  return BELTS.find(belt => belt.id === id)
}

export function byNameWithoutDegree(name) {
  const belt = byName(name)
  if (!belt) return name

  return belt.id > 8 ? byName('black') : belt
}

export function isBeltForAge(beltName, age) {
  const beltNamesForAge = belts({ forAge: age }).map(b => b.name)

  return beltNamesForAge.includes(beltName)
}

export function isBlackBelt(name) {
  // Consider all non-colored belts, including graduated black belts.
  const coloredBeltNames = BELTS.filter(belt => belt.id < 8).map(belt => belt.name)

  return !coloredBeltNames.includes(name)
}

export function beltNamesByFederation(federationAbbr) {
  if (['CBJJ', 'FPJJB'].includes(federationAbbr)) {
    return {
      white: 'Branca',
      grey: 'Cinza',
      yellow: 'Amarela',
      orange: 'Laranja',
      green: 'Verde',
      blue: 'Azul',
      purple: 'Roxa',
      brown: 'Marrom',
      black: 'Preta',
      'black-1': 'Preta 1º Grau',
      'black-10': 'Vermelha 10º Grau',
      'black-2': 'Preta 2º Grau',
      'black-3': 'Preta 3º Grau',
      'black-4': 'Preta 4º Grau',
      'black-5': 'Preta 5º Grau',
      'black-6': 'Preta 6º Grau',
      'red-and-black': 'Vermelha e Preta 7º Grau',
      'red-and-white': 'Vermelha e Branca 8º Grau',
      'black-9': 'Vermelha 9º Grau'
    }
  } else {
    return {
      white: 'White',
      grey: 'Grey',
      yellow: 'Yellow',
      orange: 'Orange',
      green: 'Green',
      blue: 'Blue',
      purple: 'Purple',
      brown: 'Brown',
      black: 'Black',
      'black-1': 'Black First Degree',
      'black-10': 'Red Tenth Degree',
      'black-2': 'Black Second Degree',
      'black-3': 'Black Third Degree',
      'black-4': 'Black Fourth Degree',
      'black-5': 'Black Fifth Degree',
      'black-6': 'Black Sixth Degree',
      'red-and-black': 'Red and Black Seventh Degree',
      'red-and-white': 'Red and White Eighth Degree',
      'black-9': 'Red Ninth Degree'
    }
  }
}
